export enum InputTypes {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  PHONE_NUMBER = "PHONE_NUMBER",
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  CURRENCY = "CURRENCY",
}
